import { Role } from '@guiker/permissions'

import { AdminRoleNames } from './role-names'

export const SuperAdministrator: Role = {
  name: AdminRoleNames.SUPER_ADMINISTRATOR,
  permissions: [{ action: '*' }],
}
